export enum AssetTypeEnum {
  VIDEO = "video",
  IMAGE = "image",
}
